<template>
  <section class="section">
    <div class="container" style="padding-top: 20px;">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <menu-lateral></menu-lateral>
          <!--
          <div class="box-aside line-top">
            <ul class="list-group menu-aside">
              <router-link tag="li" class="list-group-item" active-class="active" to="/adminpedidos">
                <a><i class="fa fa-cutlery"></i> <span>Pedidos</span> <i class="fa fa-angle-right"></i></a>
              </router-link>
              <li class="list-group-item active">
                <a><i class="fa fa-user"></i>  <span>Usuarios</span> <i class="fa fa-angle-right"></i></a>
                <ul class="subnav">
                  <li>
                    <a :href="'#/newuser/' + sucursal._id">Nuevo usuario</a>
                  </li>
                  <router-link tag="li" to="/invitarusuarios">
                    <a>Invitar usuario</a>
                  </router-link>
                </ul>
              </li>
              <li class="list-group-item"><a href="historial_empresa.html"><i class="fa fa-list"></i>  <span>Historial Empresa</span> <i class="fa fa-angle-right"></i></a></li>
              <li class="list-group-item"><a href="liquidaciones.html"><i class="fa fa-dollar"></i>  <span>Liquidaciones</span> <i class="fa fa-angle-right"></i></a></li>
            </ul>
          </div>
          -->
        </div>
        <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
          <div class="row" style="margin-bottom:20px;">
            <div class="col-md-4">
              <ul class="breadcrumbs" style="position:initial; top:0px;">
                <li>Administración</li>
                <li><i class="fa fa-angle-right"></i></li>
                <li class="active">Usuarios</li>
              </ul>
            </div>
            <div class="col-md-8 text-right">
          <div  v-if="user.sucursalesAdministradas.length>1">
                      <b class="text-brand">Sucursal</b>
                      <div class="btn-group">
                        <button class="btn btn-brand dropdown-toggle" data-toggle="dropdown" id="dd1" aria-expanded="true">
                          {{sucursal.denominacion}}  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu super" aria-labelledby="dd1">
                          <li v-for="suc in user.sucursalesAdministradas">
                            <a :href="'#/usuarios/sucursal/' + suc" @click="cambiarSucursal(getSucursal(suc))">{{getSucursal(suc).denominacion}}</a>
                          </li>
                        </ul>
                      </div>
          </div>

            </div>
          </div>


          <div class="box-style line-top">
            <div class="panel-group smart-accordion-default" id="accordion">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <div class="panel-title box-header">
                    <a data-toggle="collapse" href="#panel1">
                      <i class="fa fa-lg fa-angle-down pull-right"></i>
                      <i class="fa fa-lg fa-angle-up pull-right"></i>
                      <div class="box-date">{{usuariosInvitados.length}} invitaciones enviadas</div>
                      <h2>INVITACIONES</h2>
                    </a>
                  </div>
                </div>
                <div id="panel1" class="panel-collapse collapse in">
                  <div class="panel-body">
                    <div class="table-header form smart-form">
                      <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" v-model="findInvitado" class="form-control" placeholder="Búsqueda rápida">
                              <span class="input-group-btn">
                              <button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 pull-right text-right">
                          <router-link to="/invitarusuarios" class="btn btn-fill">NUEVA INVITACIÓN</router-link>
                        </div>
                      </div>
                    </div>
                    <div class="table-container">
                      <table class="table table-hover table-stripped table-no-first-pad">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>E-mail</th>
                            <th>Fecha invitación</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="usuario in invitadosFiltrados" :key="usuario._id">
                            <td>{{usuario.firstName}} {{usuario.lastName}}</td>
                            <td>{{usuario.email}}</td>
                            <td>{{usuario.fecha | formatearFecha}}</td>
                            <td>
                              <ul class="table-actions smart-form">
                                <!--
                                <li>
                                  <a href="" class="btn btn-xs btn-ghost" type="button">
                                    <i class="fa fa-actions fa-mail-forward"></i>
                                  </a>
                                </li>
                              -->
                                <li>
                                  <a href="" class="btn btn-xs btn-ghost" type="button" @click.prevent="onClickEliminarInvitado(usuario._id)">
                                    <i class="fa fa-actions fa-times"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading">
                  <div class="panel-title box-header subline-top">
                    <a data-toggle="collapse" href="#panel2">
                      <i class="fa fa-lg fa-angle-down pull-right"></i>
                      <i class="fa fa-lg fa-angle-up pull-right"></i>
                      <div class="box-date">{{usuariosRegistrados.length}} usuarios </div>
                      <h2>USUARIOS</h2>
                    </a>
                  </div>
                </div>
                <div id="panel2" class="panel-collapse collapse in">
                  <div class="panel-body">
                    <div class="table-header form smart-form">
                      <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-8">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control" v-model="findUsuario" placeholder="Búsqueda rápida">
                              <span class="input-group-btn">
                              <button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 pull-right text-right">
                          <a :href="'#/newuser/' + sucursal._id" class="btn btn-fill">NUEVO USUARIO</a>
                        </div>
                      </div>
                    </div>
                    <div class="table-container">
                      <table class="table table-hover table-stripped table-no-first-pad">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Legajo</th>
                            <th>Sucursal</th>
                            <th class="derecha">Acciones</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-for="(usuario, idx) in usuariosFiltrados" :key="usuario._id">
                          <tr>
                            <td>
                              {{usuario.displayName}}
                              <span class="label label-admin" v-if="usuario.roles[0] === 'admincliente'">ADMIN</span>
                              <span class="label label-danger" v-if="!usuario.activado">INACTIVO</span>
                            </td>
                            <td>{{usuario.email}}</td>
                            <td style="width:100px">
                              <span v-show="!usuario.editing"
                                    @click="toggleEdit(ev, usuario, idx)">{{usuario.legajo?usuario.legajo:"Editar"}}</span>
                              <input type="text"
                                     class="form-control form-control-sm"
                                     v-model="usuario.legajo"
                                     v-show="usuario.editing"
                                     @blur="saveEditLegajo(ev, usuario, idx)">
                            </td>
                            <td>
                              <span v-if="!usuario.editarSucursal">{{usuario.sucursalAsociada.denominacion}}</span>
                              <template v-else>
                                <div class="input-group input-group-sm">
                                  <select :value="usuario.sucursalAsociada._id" v-model="usuario.nuevaSucursal" class="form-control">
                                    <option :value="sucursal._id" v-for="sucursal in sucursales" :key="sucursal._id">{{sucursal.denominacion}}</option>
                                  </select>
                                  <span class="input-group-addon btn btn-fill" @click="onClickCambiarSucursal(usuario)"><i class="fa fa-check" aria-hidden="true"></i></span>
                                </div>
                              </template>

                            </td>
                            <td>
                              <ul class="table-actions smart-form" v-if="user._id !== usuario._id">
                                <li v-if="usuario.roles[0] === 'user' && usuario.activado">
                                  <a class="btn btn-xs btn-ghost" type="button" title="Hacer admin" @click="onClickCambiarRol(usuario._id, 'admincliente', usuario)">
                                    <i class="fa fa-users" aria-hidden="true"></i>
                                  </a>
                                </li>
                                <li v-if="usuario.roles[0] === 'admincliente'">
                                  <a class="btn btn-xs btn-ghost" type="button" title="Hacer usuario normal" @click="onClickCambiarRol(usuario._id, 'user', usuario)">
                                    <i class="fa fa-user-o" aria-hidden="true"></i>
                                  </a>
                                </li>
                                <li v-if="usuario.activado">
                                  <a class="btn btn-xs btn-ghost" type="button" title="Desactivar" @click="onClickCambiarActivo(usuario._id, false)">
                                    <i class="fa fa-actions fa-user-times"></i>
                                  </a>
                                </li>
                                <li v-else>
                                  <a class="btn btn-xs btn-ghost" type="button" title="Activar" @click="onClickCambiarActivo(usuario._id, true)">
                                    <i class="fa fa-actions fa-user-plus"></i>
                                  </a>
                                </li>
                                <li>
                                  <a class="btn btn-xs btn-ghost" type="button" title="Cambiar sucursal" @click="toggleCambiarSucursal(usuario)">
                                    <i class="fa fa-building-o"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading">
                  <div class="panel-title box-header subline-top">
                    <a data-toggle="collapse" href="#panel2">
                      <i class="fa fa-lg fa-angle-down pull-right"></i>
                      <i class="fa fa-lg fa-angle-up pull-right"></i>
                      <div class="box-date">{{usuariosAdministradores.length}} usuarios </div>
                      <h2>ADMINISTRADORES</h2>
                    </a>
                  </div>
                </div>
                <div id="panel2" class="panel-collapse collapse in">
                  <div class="panel-body">
                    <div class="table-header form smart-form">
                      <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-8">
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 pull-right text-right">
                          <a href="" @click.prevent="abrirModalAdmins()" class="btn btn-fill">AGREGAR ADMINISTRADOR</a>
                        </div>
                      </div>
                    </div>
                    <div class="table-container">
                      <table class="table table-hover table-stripped table-no-first-pad">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Legajo</th>
                            <th>Sucursal</th>
                            <th class="derecha">Acciones</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-for="(usuario, idx) in usuariosAdministradores" :key="usuario._id">
                          <tr>
                            <td>
                              {{usuario.displayName}}
                              <span class="label label-admin" v-if="usuario.roles[0] === 'admincliente'">ADMIN</span>
                              <span class="label label-danger" v-if="!usuario.activado">INACTIVO</span>
                            </td>
                            <td>{{usuario.email}}</td>
                            <td style="width:100px">
                              <span>{{usuario.legajo?usuario.legajo:""}}</span>
                            </td>
                            <td>
                              <span>{{usuario.sucursalAsociada.denominacion}}</span>
                            </td>
                            <td>
                              <ul class="table-actions smart-form" v-if="user._id !== usuario._id">
                                <li v-if="usuario.roles[0] === 'user' && usuario.activado">
                                  <a class="btn btn-xs btn-ghost" type="button" title="Hacer admin" @click="onClickCambiarRol(usuario._id, 'admincliente', usuario)">
                                    <i class="fa fa-users" aria-hidden="true"></i>
                                  </a>
                                </li>
                                <li v-if="usuario.roles[0] === 'admincliente'">
                                  <a class="btn btn-xs btn-ghost" type="button" title="Hacer usuario normal" @click="onClickCambiarRol(usuario._id, 'user', usuario)">
                                    <i class="fa fa-user-o" aria-hidden="true"></i>
                                  </a>
                                </li>
                                <li v-if="usuario.activado">
                                  <a class="btn btn-xs btn-ghost" type="button" title="Desactivar" @click="onClickCambiarActivo(usuario._id, false)">
                                    <i class="fa fa-actions fa-user-times"></i>
                                  </a>
                                </li>
                                <li v-else>
                                  <a class="btn btn-xs btn-ghost" type="button" title="Activar" @click="onClickCambiarActivo(usuario._id, true)">
                                    <i class="fa fa-actions fa-user-plus"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

    <div class="modal" ref="modalAdministradores" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">ADMINISTRADORES DISPONIBLES EN LA EMPRESA</h4>
          </div>
            <div class="modal-body">
              <div class="smart-form">
                <div v-if="loadingAdmins" class="col-md-12 text-center">
                  <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                </div>
                <div class="col-xs-12 col-md-12 ">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="text" class="form-control" v-model="findAdmin" placeholder="Búsqueda rápida">
                              <span class="input-group-btn">
                              <button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
                              </span>
                            </div>
                          </div>
                </div>                
                <div v-if="!loadingAdmins" class="form-group" v-for="admin in adminsFiltrados">
                    <a href="" @click.prevent="toggleAdmin(admin)">
                      <i class="fa fa-check-square-o" v-if="adminDeEstaSucursal(admin)"></i>
                      <i class="fa fa-square-o" v-else></i>
                    </a>
                    <span @click.prevent="toggleAdmin(admin)" style="cursor:pointer">{{admin.displayName}}</span>
                </div>
                <div class="form-group">
                  <div class="text-center center-block">
                    <button class="btn btn-fill" @click="cerrarModal()">Guardar</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    </div>
  </section>
</template>
<script>
  import moment from 'moment'
  import MenuLateral from './MenuLateralAdmin'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'
  import { find, findIndex } from 'lodash'
  import $ from 'jquery'

  export default {
    props: ['user'],
    components: {
      'menu-lateral': MenuLateral
    },
    computed: {
      invitadosFiltrados () {
        const me = this
        let invitados = me.usuariosInvitados
        if (me.findInvitado.trim() !== '') {
          invitados = invitados.filter((invitado) => {
            return invitado.firstName.toLowerCase().includes(me.findInvitado.toLowerCase().trim()) || invitado.lastName.toLowerCase().includes(me.findInvitado.toLowerCase().trim()) || invitado.email.toLowerCase().includes(me.findInvitado.toLowerCase().trim())
          })
        }
        return invitados
      },
      adminsFiltrados () {
        const me = this
        let admins = me.admins
        if (me.findAdmin.trim() !== '') {
          admins = admins.filter((usuario) => {
            return usuario.displayName.toLowerCase().includes(me.findAdmin.toLowerCase().trim()) || usuario.email.toLowerCase().includes(me.findAdmin.toLowerCase().trim())
          })
        }
        return admins
      },
      usuariosFiltrados () {
        const me = this
        let usuarios = me.usuariosRegistrados
        if (me.findUsuario.trim() !== '') {
          usuarios = usuarios.filter((usuario) => {
            return usuario.displayName.toLowerCase().includes(me.findUsuario.toLowerCase().trim()) || usuario.email.toLowerCase().includes(me.findUsuario.toLowerCase().trim())
          })
        }
        return usuarios
      }
    },
    data () {
      return {
        findInvitado: '',
        findUsuario: '',
        findAdmin: '',
        sucursales: [],
        sucursal: {},
        usuariosInvitados: [],
        usuariosRegistrados: [],
        todasLasSucursales: false,
        usuariosAdministradores: [],
        loadingAdmins: false,
        admins: []
      }
    },
    filters: {
      formatearFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      }
    },
    methods: {
      toggleAdmin: function (admin) {
        const me = this
        let idx = findIndex(admin.sucursalesAdministradas, function (o) { return o._id === me.sucursal._id })
        if (idx === -1) {
          swal({
            title: 'Confirme operación',
            text: '¿Desea hacer administrador de esta sucursal a este usuario?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No, dejar sin efecto'
          }).then(() => {
            admin.sucursalesAdministradas.push(me.sucursal)
            me.cambiarRolOtraSucursal(admin, 'true')
          }, (dismiss) => {
            return false
          })
        } else {
          swal({
            title: 'Confirme operación',
            text: '¿Desea sacar el permiso de administrador de esta sucursal a este usuario?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No, dejar sin efecto'
          }).then(() => {
            admin.sucursalesAdministradas.splice(idx, 1)
            me.cambiarRolOtraSucursal(admin, 'false')
          }, (dismiss) => {
            return false
          })
        }
      },
      cambiarRolOtraSucursal: function (admin, add) {
        const me = this
        me.$http.post('/api/users/permisossucursal', {
          id: admin._id,
          sucursal: me.sucursal._id,
          add: add
        }).then(({body}) => {
          if (add) {
            me.$emit('mostrar-notificacion', 'El usuario ahora es administrador de esta sucursal', 'success')
          } else {
            me.$emit('mostrar-notificacion', 'El usuario ya no es administrador de esta sucursal', 'success')
          }
          me.$http.get('/api/users/admins', {
            params: { id: me.sucursal._id }
          }).then(({body}) => {
            console.log('entra al refresh:', body)
            me.usuariosAdministradores = body[0]
          }, (err) => {
            console.error(err)
          })
        }, (err) => {
          console.error(err)
        })
      },
      cerrarModal: function () {
        const me = this
        $(me.$refs.modalAdministradores).modal('hide')
      },
      adminDeEstaSucursal: function (admin) {
        const me = this
        let isAdmin = false
        admin.sucursalesAdministradas.forEach(suc => {
          if (suc._id === me.sucursal._id) {
            isAdmin = true
          }
        })
        return isAdmin
      },
      abrirModalAdmins: function () {
        const me = this
        me.loadingAdmins = true
        $(me.$refs.modalAdministradores).modal()
        me.$http.get('/api/users/empresaAdmins', {params: {empresa: me.sucursal.empresa, sucursal: me.sucursal._id}}).then(({body}) => {
          me.admins = body[0]
          me.loadingAdmins = false
        }, (err) => {
          console.log(err)
        })
      },
      getSucursal: function (suc) {
        const me = this
        return find(me.sucursales, function (o) { return o._id === suc })
      },
      cambiarSucursal: function (sucursal) {
        const me = this
        me.sucursal = sucursal
        me.$http.get('/api/users/initusuarios', {params: {id: me.sucursal._id}}).then(({body}) => {
          const usuariosRegistrados = body[0]
          usuariosRegistrados.forEach(u => {
            u.editarSucursal = false
            u.sucursalAsociada = Object.assign({}, sucursal)
            u.nuevaSucursal = u.sucursalAsociada._id
          })
          me.usuariosRegistrados = usuariosRegistrados
          me.usuariosInvitados = body[1]
          me.sucursales = body[2]
          me.usuariosAdministradores = body[3]
        }, (err) => {
          console.log(err)
        })
      },
      toggleTodasLasSucursales: function () {
        const me = this
        me.todasLasSucursales = !me.todasLasSucursales
      },
      toggleEdit: function (ev, user, idx) {
        this.$set(this.usuariosFiltrados, idx, Object.assign({}, this.usuariosFiltrados[idx], {editing: true}))
      },
      saveEditLegajo: function (ev, user, idx) {
        this.$set(this.usuariosFiltrados, idx, Object.assign({}, this.usuariosFiltrados[idx], {editing: false}))
        const me = this
        me.$http.post('/api/users/guardarlegajo', {
          id: user._id,
          legajo: user.legajo
        }).then(({body}) => {
          me.$emit('mostrar-notificacion', 'Se guardo el legajo', 'success')
        }, (err) => {
          console.error(err)
          me.$emit('mostrar-notificacion', 'No se pudo guardar el legajo', 'error')
        })
      },
      cambiarRol (id, rol) {
        const me = this
        me.$http.post('/api/users/cambiarrol', {
          id: id,
          rol: rol,
          sucursal: me.sucursal._id
        }).then(({body}) => {
          const idx = me.usuariosRegistrados.findIndex(u => u._id === id)
          const user = me.usuariosRegistrados.find(u => u._id === id)
          if (idx >= 0) {
            user.roles[0] = rol
            me.usuariosRegistrados.splice(idx, 1, user)
          }
          me.$http.get('/api/users/admins', {
            params: { id: me.sucursal._id }
          }).then(({body}) => {
            console.log('entra al refresh:', body)
            me.usuariosAdministradores = body[0]
          }, (err) => {
            console.error(err)
          })
        }, (err) => {
          console.error(err)
        })
      },
      eliminarInvitado (id) {
        const me = this
        console.log('eliminar', id)
        me.$http.post('/api/users/eliminarinvitado', {
          id: id
        }).then(({body}) => {
          let invitadoABorrar = me.usuariosInvitados.find((invitado) => {
            return invitado._id === id
          })
          me.usuariosInvitados.splice(me.usuariosInvitados.indexOf(invitadoABorrar), 1)
        }, (err) => {
          console.error(err)
        })
      },
      onClickCambiarRol (id, rol, user) {
        const me = this
        swal({
          title: 'Confirme operación',
          text: '¿Desea cambiar el rol del usuario?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No, dejar sin efecto'
        }).then(() => {
          if (user.sucursalesAdministradas.length > 1 && rol === 'user' && user.sucursalAsociada._id === me.sucursal._id) {
            swal({
              title: 'Confirme operación',
              text: 'El usuario también administra otras sucursales, si le saca el permiso de administrador, perderá los privilegios en las otras sucursales también ¿Desea cambiar el rol del usuario?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Si',
              cancelButtonText: 'No, dejar sin efecto'
            }).then(() => {
              me.cambiarRol(id, rol)
            }, (dismiss) => {
              return false
            })
          } else {
            me.cambiarRol(id, rol)
          }
        }, (dismiss) => {
          return false
        })
      },
      onClickEliminarInvitado (id) {
        const me = this
        swal({
          title: 'Confirme operación',
          text: '¿Desea eliminar la invitación?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No, dejar sin efecto'
        }).then(() => {
          me.eliminarInvitado(id)
        }, (dismiss) => {
          return false
        })
      },
      cambiarEstadoActivo (id, valor) {
        const me = this
        me.$http.post('/api/users/cambiarestadoactivo', {
          valor: valor,
          id: id
        }).then(({body}) => {
          let usuarioCambiado = me.usuariosRegistrados.find((usuario) => {
            return usuario._id === id
          })
          usuarioCambiado.activado = valor
        }, (err) => {
          console.error(err)
        })
      },
      onClickCambiarActivo (id, valor) {
        const me = this
        swal({
          title: 'Confirme operación',
          text: '¿Desea cambiar el estado del usuario seleccionado?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No, dejar sin efecto'
        }).then(() => {
          me.cambiarEstadoActivo(id, valor)
        }, (dismiss) => {
          return false
        })
      },
      onClickCambiarSucursal (usuario) {
        const me = this
        if (usuario.nuevaSucursal !== usuario.sucursalAsociada._id) {
          swal({
            title: 'Confirme operación',
            text: '¿Desea cambiar la sucursal del usuario?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No, dejar sin efecto'
          }).then(() => {
            me.$http.post('/api/users/cambiarsucursal', {
              idUsuario: usuario._id,
              nuevaSucursal: usuario.nuevaSucursal,
              sucursalActual: usuario.sucursalAsociada._id
            }).then(({body}) => {
              me.usuariosRegistrados.splice(me.usuariosRegistrados.indexOf(usuario), 1)
              let texto
              if (usuario.coincidenSucursales) {
                texto = 'Los pedidos del usuario para fechas futuras llegarán a la nueva sucursal'
              } else {
                texto = 'Los pedidos del usuario para fechas futuras fueron cancelados, deben realizarse nuevamente'
              }
              swal({
                title: 'Operación exitosa',
                text: texto,
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Entendido'
              })
            }, err => console.error(err))
          }, (dismiss) => {
            me.toggleCambiarSucursal(usuario)
            return false
          })
        }
      },
      toggleCambiarSucursal (usuario) {
        usuario.editarSucursal = !usuario.editarSucursal
      }
    },
    mounted () {
      const me = this
      const user = me.user
      if (me.$route.params.sucursal) {
        me.sucursal = { _id: me.$route.params.sucursal }
      } else {
        me.sucursal = me.user.sucursalAsociada
      }
      me.$http.get('/api/users/initusuarios', {params: {id: me.sucursal._id}}).then(({body}) => {
        const usuariosRegistrados = body[0]
        usuariosRegistrados.forEach(u => {
          u.editarSucursal = false
          u.sucursalAsociada = Object.assign({}, user.sucursalAsociada)
          u.nuevaSucursal = u.sucursalAsociada._id
        })
        me.usuariosRegistrados = usuariosRegistrados
        me.usuariosInvitados = body[1]
        me.sucursales = body[2]
        me.usuariosAdministradores = body[3]
      }, (err) => {
        console.log(err)
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Usuarios.vue?3d6f727a